import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Import styles before App to ensure CSS is loaded first
import './styles/fonts.css';
import './styles/app.css';

import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';

// Hide splash screen after app loads
const hideSplash = () => {
  const splash = document.getElementById('splash');
  const root = document.getElementById('root');

  if (splash) {
    splash.classList.add('splash-fadeout');
    setTimeout(() => {
      splash.classList.add('splash-hidden');
    }, 300);
  }

  if (root) {
    root.classList.add('root-fadein');
  }
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);

// Trigger splash fade after a short delay to ensure smooth transition
setTimeout(hideSplash, 100);
